export class PortCallClaims {
  static TYPE = 'Port Call';
  static buttonRowPermissions = {
    view: false,
    edit: false,
    clearance: false,
    cancel: false,
    delete: false
  };
  static portCallPermissions = {
    register: false,
    edit: false,
    clearance: false
  };
}



// WEBPACK FOOTER //
// ./src/app/shared/constants/port-call-claims.ts